// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Standardized Sermorelin intake 6/1/26 09.17.26" (57b93fa7-8751-4c80-96ba-7af5f1b686cf). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiStandardizedSermorelinIntakeQuestions = [
  {
    field:
      'mdiStandardizedSermorelinIntake_symptomsHavingBenefittedSermorelinTreatment',
    label:
      'What symptoms are you having that would be benefitted by Sermorelin treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'fatigue', value: 'Fatigue' },
        { key: 'muscle_mass_reduced', value: 'Muscle Mass Reduced' },
        { key: 'low_endurance', value: 'Low Endurance' },
        { key: 'muscle_weakness', value: 'Muscle Weakness' },
        { key: 'weight_gain', value: 'Weight Gain' },
        { key: 'sleeping_difficulties', value: 'Sleeping Difficulties' },
        { key: 'low_energy', value: 'Low Energy' },
        { key: 'chronic_fatigue', value: 'Chronic Fatigue' },
        { key: 'brain_fog', value: 'Brain Fog' },
        { key: 'lack_of_focus', value: 'Lack of Focus' },
        { key: 'low_libido', value: 'Low libido' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'other_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'd206ac42-7d50-4a70-868c-bb1de7d8a618' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_injuriesSurgeriesWithinLast6',
    label: 'Have you had any injuries or surgeries within the last 6 months?',
    type: 'select',
    educationalSlide:
      'If yes, please provide as much information as possible for your doctor.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'f9ca9d19-5843-4596-9922-dd309f0eb783' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_apply',
    label: 'Do any of the following apply to you?',
    type: 'select',
    educationalSlide:
      'If you answer yes to any of these questions, please provide as much information as possible so your doctor can determine if this treatment is appropriate and safe for you.\n\n• If you have hypothyroidism, this should be controlled prior to starting Sermorelin or your treatment may not be effective.\n• If you have a current or previous Glioma, you are not eligible for Sermorelin as your unique condition poses a safety risk.\n• If you have any type of cancer currently, or in remission, you have a unique risk that is not present in those without cancer; you should discuss further with your doctor prior to starting any treatment with sermorelin.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'hypothyroidism',
          value: 'Hypothyroidism',
          answer: {
            type: 'text',
            name: 'hypothyroidism_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'current_or_history_of_glioma',
          value: 'Current or history of glioma',
          answer: {
            type: 'text',
            name: 'current_or_history_of_glioma_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'active_cancer_or_history_of_cancer',
          value: 'Active cancer or history of cancer',
          answer: {
            type: 'text',
            name: 'active_cancer_or_history_of_cancer_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '6a97d433-0e4b-4901-a209-3e7ee52ef5f5' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_imSorryDueMedicalConditions',
    label:
      "I'm sorry, due to your medical conditions, it is not safe for you to take Sermorelin.",
    type: 'info',
    subLabel:
      'Please reach out to [customer_support_email] for more information.',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '003d5016-7b88-4d1f-bfa5-41b4df592040',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_takeMedications',
    label: 'Do you take any of the following medications?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'clonidine_or_levodopa', value: 'Clonidine or Levodopa' },
        {
          key: 'octreotide_lanreotide_or_pasireotide',
          value: 'Octreotide, lanreotide, or pasireotide'
        },
        {
          key: 'glucocorticoids_such_as_prednisone_dexam',
          value: 'Glucocorticoids (such as prednisone, dexamethasone)'
        },
        {
          key: 'cox_inhibitors_aspirin_advil_celebrex_or',
          value: 'COX inhibitors (Aspirin, Advil, Celebrex, or similar)'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '04986fbd-6f56-4ba0-86e0-8c616545b76b' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_apply2',
    label: 'Please select all that apply',
    type: 'select',
    educationalSlide:
      'This question is required to evaluate the safety of your prescription. Your answers are confidential and protected by federal law under HIPAA. We cannot and do not disclose any information from your answers. If you answer yes please provide as much information to your doctor so they can determine if this treatment is appropriate and safe for you.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'i_binge_drink_4_or_more_alcoholic_drinks',
          value: 'I binge drink (4 or more alcoholic drinks at one time)',
          answer: {
            type: 'text',
            name: 'i_binge_drink_4_or_more_alcoholic_drinks_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'i_take_opiates_prescription_or_recreatio',
          value: 'I take opiates (prescription or recreational)',
          answer: {
            type: 'text',
            name: 'i_take_opiates_prescription_or_recreatio_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'none_of_this_applies_to_me',
          value: 'NONE of this applies to me'
        }
      ]
    },
    required: false,
    extras: { mdiQuestionId: 'd3bd9cfd-438a-4882-9539-9def6173341f' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent   (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiStandardizedSermorelinIntake_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '6668cf34-a0f9-460b-b353-35bae94bcb2e' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_elseLikeTellDoctorWho',
    label:
      'What else would you like to tell the doctor who will be evaluating you? This is your first message to your doctor.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiStandardizedSermorelinIntake_elseLikeTellDoctorWho',
      placeholder:
        'Example: "Hi doctor, other than what I already answered I am otherwise health and excited to get started."'
    },
    extras: { mdiQuestionId: '2b61717b-62ee-4039-ba1f-7d20cbd46e47' }
  },
  {
    field: 'mdiStandardizedSermorelinIntake_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiStandardizedSermorelinIntakeAnswerField = Partial<
  QuestionAnswerMap<typeof mdiStandardizedSermorelinIntakeQuestions>
>;

export default mdiStandardizedSermorelinIntakeQuestions;
